import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/user';
import {Router} from '@angular/router';
import {AppConfigService} from './appconfig.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    public currentUserSubject = new BehaviorSubject<User>({});
    public currentUser: Observable<User>;
    public userNameField: string;
    public resetAccount;
    public resetOptions;
    public resetOptionsObservable = new BehaviorSubject(false);
    public resetPasswordObservable = new BehaviorSubject(false);
    public updateNotificationObservable = new BehaviorSubject(false);
    constructor(private http: HttpClient, public router: Router, private appConfigService: AppConfigService) {
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
      this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string, captcha: any) {
        return this.http.post<any>(`${this.appConfigService.configData.apiUrl}/users/login`,
          {email: username, password,  'g-recaptcha-response': captcha})
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }
                return user;
            }));
    }

    logout() {
        return this.http.get<any>(`${this.appConfigService.configData.apiUrl}/users/auth/logout`)
          .pipe(map(() => {
              // login successful if there's a jwt token in the response
              // remove user from local storage to log user out
              return;
          }));
    }


    getSession() {
      return this.http.get(`${this.appConfigService.configData.apiUrl}/users/me`)
            .pipe(map((data: any) => {
              const user = {
                token: this.currentUserSubject.value.token,
                user: data
              };
              localStorage.setItem('currentUser', JSON.stringify(user));
              this.currentUserSubject.next(user);
              return user;
            }, () => {
              this.router.navigate(['auth/login']);
            }));
    }
}
